import React, { useEffect, useRef } from "react";
import ReactDOM from "react-dom";
import { useNavigate } from "react-router-dom";
import { Monitor, Users, Cog, CreditCard, Share2, LogOut, HelpCircle, MessageCircle } from "lucide-react";
import { FaWhatsapp } from "react-icons/fa";
import { getMyAgencies } from "../../actions/agencies";
import { useAuth } from "../../context/AuthContext";
import { showToast } from "../../utils/toastUtils";
import { trackEvent } from "../../utils/clarity";
import { usePremiumAccess } from "../../hooks/usePremiumAccess"; // ✅ Importa o hook direto
var HeaderMenuModal = function (_a) {
    var onClose = _a.onClose, highlightClients = _a.highlightClients, _b = _a.notifications, notifications = _b === void 0 ? [] : _b, isDemo = _a.isDemo;
    var navigate = useNavigate();
    var logoutUser = useAuth().logoutUser;
    var ref = useRef(null);
    var _c = React.useState("5562983321754"), affiliateWhatsapp = _c[0], setAffiliateWhatsapp = _c[1];
    // ✅ Usa o hook centralizado para acesso premium/trial
    var _d = usePremiumAccess(), isInTrialPeriod = _d.isInTrialPeriod, hasActivePlan = _d.hasActivePlan, isLoading = _d.isLoading;
    useEffect(function () {
        getMyAgencies().then(function (agencies) {
            if (agencies && agencies.length > 0) {
                var agency = agencies[0];
                if (agency.affiliate && agency.affiliate.whatsapp) {
                    setAffiliateWhatsapp(agency.affiliate.whatsapp.replace(/\D/g, ""));
                }
            }
        });
    }, []);
    useEffect(function () {
        var prevOverflow = document.body.style.overflow;
        document.body.style.overflow = "hidden";
        return function () {
            document.body.style.overflow = prevOverflow || "";
        };
    }, []);
    useEffect(function () {
        function onKey(e) {
            if (e.key === "Escape")
                onClose();
        }
        function onDown(e) {
            if (ref.current && !ref.current.contains(e.target))
                onClose();
        }
        document.addEventListener("keydown", onKey);
        document.addEventListener("mousedown", onDown);
        return function () {
            document.removeEventListener("keydown", onKey);
            document.removeEventListener("mousedown", onDown);
        };
    }, [onClose]);
    // ✅ Calcula se deve mostrar opções do menu
    var showMenuOptions = isInTrialPeriod || (!isInTrialPeriod && hasActivePlan);
    // Exibe loader enquanto dados premium/trial estão carregando
    if (isLoading) {
        return ReactDOM.createPortal(React.createElement("div", { className: "fixed right-8 top-16 w-[300px] bg-gray-900 border border-gray-700 rounded-lg shadow-xl z-[100000] overflow-hidden flex items-center justify-center py-8" },
            React.createElement("span", { className: "text-gray-300 text-sm" }, "Carregando informa\u00E7\u00F5es da ag\u00EAncia...")), document.body);
    }
    var modalContent = (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "fixed inset-0 bg-black/60 z-[99999] pointer-events-auto" }),
        React.createElement("div", { ref: ref, role: "dialog", "aria-modal": "true", className: "fixed right-8 top-16 w-[300px] bg-gray-900 border border-gray-700 rounded-lg shadow-xl z-[100000] overflow-hidden" },
            React.createElement("div", { className: "py-2" },
                showMenuOptions && (React.createElement(React.Fragment, null,
                    React.createElement("button", { className: "w-full text-left px-5 py-3 hover:bg-gray-800 flex items-center gap-2 text-white", onClick: function () { navigate("/monitoramento"); onClose(); } },
                        React.createElement(Monitor, { className: "w-5 h-5 text-cyan-400" }),
                        "Monitoramento"),
                    React.createElement("button", { className: "w-full text-left px-5 py-3 flex items-center gap-2 font-semibold text-white\n                ".concat(highlightClients ? "bg-green-900 text-green-300 animate-pulse ring-2 ring-green-400" : "hover:bg-gray-800", "\n              "), onClick: function () {
                            if (isDemo) {
                                showToast("error", "Apenas usuários com agências ativas podem ativar e desativar clientes e assinaturas.");
                                onClose();
                                return;
                            }
                            navigate("/clients");
                            onClose();
                        } },
                        React.createElement(Users, { className: "w-5 h-5 text-blue-400" }),
                        React.createElement("span", null, "Meus Clientes")),
                    React.createElement("button", { className: "w-full text-left px-5 py-3 hover:bg-gray-800 flex items-center gap-2 text-white", onClick: function () { navigate("/settings"); onClose(); } },
                        React.createElement(Cog, { className: "w-5 h-5 text-green-400" }),
                        "Configura\u00E7\u00F5es"),
                    React.createElement("button", { className: "w-full text-left px-5 py-3 hover:bg-gray-800 flex items-center gap-2 text-white", onClick: function () {
                            if (isDemo) {
                                showToast("error", "Apenas usuários com agências ativas podem ativar e desativar clientes e assinaturas.");
                                onClose();
                                return;
                            }
                            navigate("/subscription");
                            onClose();
                        } },
                        React.createElement(CreditCard, { className: "w-5 h-5 text-pink-400" }),
                        "Assinatura"),
                    React.createElement("button", { className: "w-full text-left px-5 py-3 hover:bg-gray-800 flex items-center gap-2 text-white", onClick: function () { navigate("/affiliate"); onClose(); } },
                        React.createElement(Share2, { className: "w-5 h-5 text-yellow-400" }),
                        "Programa de Afiliados"),
                    React.createElement("button", { className: "w-full text-left px-5 py-3 hover:bg-gray-800 flex items-center gap-2 text-white", onClick: function () { navigate("/feedbacks"); onClose(); } },
                        React.createElement(MessageCircle, { className: "w-5 h-5 text-purple-400" }),
                        "Meus Feedbacks"))),
                React.createElement("a", { href: "https://wa.me/".concat(affiliateWhatsapp, "?text=Ol\u00E1! Preciso de ajuda com o Vision Cockpit"), target: "_blank", rel: "noopener noreferrer", className: "w-full text-left px-5 py-3 hover:bg-gray-800 flex items-center gap-2 text-green-400 font-semibold", onClick: onClose },
                    React.createElement(HelpCircle, { className: "w-5 h-5" }),
                    "Ajuda"),
                React.createElement("button", { className: "w-full text-left px-5 py-3 hover:bg-gray-800 text-red-400 flex items-center gap-2", onClick: function () {
                        trackEvent('auth_logout');
                        logoutUser();
                        navigate("/login");
                        onClose();
                        showToast("success", "Logout realizado com sucesso!");
                    } },
                    React.createElement(LogOut, { className: "w-5 h-5" }),
                    "Sair"),
                notifications.length > 0 && (React.createElement("div", { className: "border-t border-gray-700 pt-4 mt-4 px-5" },
                    React.createElement("h3", { className: "text-sm font-semibold text-gray-400 mb-3" }, "Notifica\u00E7\u00F5es"),
                    React.createElement("div", { className: "space-y-2" }, notifications.map(function (notif, idx) { return (React.createElement("button", { key: idx, onClick: function () {
                            notif.onClick();
                            onClose();
                        }, className: "w-full text-left px-3 py-2 rounded-lg transition flex items-center gap-3 ".concat(notif.type === 'whatsapp'
                            ? 'bg-yellow-500/10 hover:bg-yellow-500/20 text-yellow-300 animate-pulse'
                            : 'bg-blue-500/10 hover:bg-blue-500/20 text-blue-300') },
                        notif.type === 'whatsapp' ? (React.createElement(FaWhatsapp, { className: "w-5 h-5 text-green-400 flex-shrink-0" })) : (React.createElement("span", { className: "text-xl flex-shrink-0" }, "\uD83D\uDD14")),
                        React.createElement("span", { className: "text-sm flex-1" }, notif.message))); }))))))));
    return ReactDOM.createPortal(modalContent, document.body);
};
export default HeaderMenuModal;
